import {Base} from '../../common/model/base.model';

export class SiperRecapito extends Base {

  constructor(protected id: number,
              public provincia: string,
              public comune: string,
              public indirizzo: string,
              public cap: string,
              public statoId: string,
              public telefono: string,
              public cellulare: string,
              public email: string
  ) {
    super(id);
  }

  public getLabel() {
    return this.indirizzo + ' ' + this.cap + ' - ' + this.comune;
  }

}
